export const messages = {
  allOrdersLabel: 'All Orders',
  payOrdersLabel: 'JOOR Pay Orders',
  sendPaymentLink: 'Send Payment Link',
  changeOrderStatus: 'Change Order Status',
  search: 'Search...',
  loadingOfTotal: (count: number, total: number) =>
    `Loading ${count} of ${total} orders`,
  totalOrders: (total: number) => `Total orders: ${total}`,
  actionsLabel: 'Actions',
  exportTableLabel: 'Export Table',
  reachDashboard: 'Reach Dashboard',
  loadThreeMonths: 'Load orders created in last 3 months',
  loadAllOrders: 'Load all orders',
  errorLayout: {
    header: 'Orders not retrieved',
    body: 'There was an error retrieving your orders.',
    please: 'Please',
    reload: 'reload the page',
    tryAgain: 'or try again later.',
  },
  loadAllTooltip:
    'This may take a while to load, depending on the total amount of orders.',
}
